module.exports = __webpack_public_path__ + "static/media/16_plantilla_rec_combo_simple_cf_gaseosas_pet_2_25_ccso.ba4d3e4d.png";